import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import { appThemeSpace } from "styles/appThemeTokens";
import { HEADER_HEIGHT } from "common/Components/Layout/TopHeader/TopHeader.constants";
import {
  getBannerAppearanceConfig,
  TOAST_BANNER_APPEARANCE,
} from "./Toast.constants";

const uiFont = appThemeFonts.family.ui;

const toastTopOffset = HEADER_HEIGHT + parseInt(appThemeSpace.xs, 10);

const statusFor = (type) => {
  if (type === "success") return appThemeColors.status.ok;
  if (type === "failure") return appThemeColors.status.crit;
  if (type === "info") return appThemeColors.status.info;
  if (type === "warn") return appThemeColors.status.warn;
  return appThemeColors.status.ok;
};

export const toastStyles = {
  snackbar: {
    top: `${toastTopOffset}px`,
    right: "20px",
    left: "auto",
    bottom: "auto",
  },
  alert: (type) => ({
    minWidth: "320px",
    maxWidth: "500px",
    alignItems: "center",
    gap: "14px",
    padding: "14px 18px",
    borderRadius: "14px",
    backgroundColor: appThemeColors.background.paper,
    color: appThemeColors.text.primary,
    border: "none",
    borderLeft: `6px solid ${statusFor(type).color}`,
    boxShadow: "0 10px 30px rgba(10, 31, 92, 0.12)",
    fontFamily: uiFont,
    "& .MuiAlert-icon": {
      padding: 0,
      margin: 0,
      opacity: 1,
      color: statusFor(type).color,
    },
    "& .MuiAlert-message": {
      padding: 0,
      minWidth: 0,
    },
  }),
  iconCircle: (type) => ({
    width: 26,
    height: 26,
    flex: "0 0 auto",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: statusFor(type).background,
    color: statusFor(type).color,
  }),
  iconGlyph: {
    fontSize: appThemeFonts.size.xl,
  },
  alertTitle: (hasDescription) => ({
    fontFamily: uiFont,
    fontSize: appThemeFonts.size.lgPlus,
    fontWeight: 700,
    color: appThemeColors.text.heading,
    margin: 0,
    marginBottom: hasDescription ? "2px" : 0,
    lineHeight: 1.35,
  }),
  description: {
    fontFamily: uiFont,
    fontSize: appThemeFonts.size.lg,
    fontWeight: 400,
    color: appThemeColors.text.muted,
    lineHeight: 1.4,
  },
  bannerAlert: (
    bannerAppearance = TOAST_BANNER_APPEARANCE.DEFAULT
  ) => {
    const config = getBannerAppearanceConfig(bannerAppearance);
    return {
      width: "100%",
      minHeight: "unset",
      alignItems: "center",
      gap: config.gap,
      padding: config.padding,
      borderRadius: config.borderRadius,
      backgroundColor: config.backgroundColor,
      color: config.textColor,
      border: config.border,
      borderLeft: `${config.borderLeftWidth} solid ${config.accentColor}`,
      boxShadow: config.boxShadow,
      fontFamily: uiFont,
      "&.MuiAlert-standardWarning": {
        backgroundColor: config.backgroundColor,
      },
      "& .MuiAlert-icon": {
        padding: 0,
        margin: 0,
        opacity: 1,
        alignSelf: "center",
        color: config.markColor,
      },
      "& .MuiAlert-message": {
        padding: 0,
        minWidth: 0,
        overflow: "visible",
      },
    };
  },
  bannerMark: (bannerAppearance = TOAST_BANNER_APPEARANCE.DEFAULT) => {
    const config = getBannerAppearanceConfig(bannerAppearance);
    return {
      width: 26,
      height: 26,
      flex: "0 0 auto",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: config.markBackgroundColor,
      color: config.markColor,
    };
  },
  bannerMarkTriangle: {
    fontSize: "13px",
    lineHeight: 1,
    fontWeight: 700,
  },
  bannerMarkIcon: {
    fontSize: appThemeFonts.size.xl,
  },
  bannerText: (bannerAppearance = TOAST_BANNER_APPEARANCE.DEFAULT) => {
    const config = getBannerAppearanceConfig(bannerAppearance);
    return {
      fontFamily: uiFont,
      fontSize:
        bannerAppearance === TOAST_BANNER_APPEARANCE.STATUS
          ? appThemeFonts.size.lgPlus
          : appThemeFonts.size.lg,
      fontWeight: config.textFontWeight,
      color: config.textColor,
      lineHeight: 1.35,
      display: "block",
    };
  },
};

export const toastCSS = `
  /* Toast component positioning overrides for MUI Snackbar */
  .toast-snackbar,
  .MuiSnackbar-root.toast-snackbar,
  .MuiSnackbar-root.MuiSnackbar-anchorOriginTopRight,
  .MuiSnackbar-anchorOriginTopRight {
    top: ${toastTopOffset}px !important;
    right: 20px !important;
    left: auto !important;
    bottom: auto !important;
    transform: translateX(0) translateY(0) !important;
  }

  /* Ensure the snackbar container is positioned correctly */
  div[class*="MuiSnackbar-root"][class*="anchorOriginTopRight"],
  div[class*="MuiSnackbar-root"].toast-snackbar {
    top: ${toastTopOffset}px !important;
    right: 20px !important;
    left: auto !important;
  }
`;
